import { render, staticRenderFns } from "./4-4.Result.vue?vue&type=template&id=0f50a052&scoped=true&lang=true"
import script from "./4-4.Result.vue?vue&type=script&lang=js"
export * from "./4-4.Result.vue?vue&type=script&lang=js"
import style0 from "./4-4.Result.vue?vue&type=style&index=0&id=0f50a052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f50a052",
  null
  
)

export default component.exports